// Neither `documentsUds` nor `meetingsUds` takes a name filter, so the tabs that
// use them match locally. Empty search matches everything.
//
// Ordering is NOT this module's job: the glist's own `sortBy`/`defaultSortBy`
// (see `../glist/module.ts`) sorts every tab's rows by date, tie-broken by
// title, so a row lands in the right place regardless of which order its
// source API happened to return it in.
export function matchesSearch(name: string, search: string): boolean {
    if (!search) {
        return true
    }

    return (name || '').toLowerCase().includes(search.toLowerCase())
}
